// src/modules/moduleDashboards/api.js
import API from '../../services/api';

// Distinct branch regions for the Area selector.
export const fetchRegions = async () => {
  const res = await API.get('/dashboard/regions');
  return res.data?.data || [];
};

// Branches for the Branch selector.
export const fetchDashboardBranches = async () => {
  const res = await API.get('/dashboard/branches');
  return res.data?.data || res.data || [];
};

// ── Dashboard Builder (admin authoring + per-user render) ──────────────

// The current user's BUILT dashboard, data included. Returns { hasLayout, ... }.
export const renderBuiltDashboard = async ({ dateRange = {}, branch } = {}) => {
  const params = {};
  if (dateRange.startDate && dateRange.endDate) {
    params.startDate = dateRange.startDate;
    params.endDate = dateRange.endDate;
  }
  if (branch && branch !== 'all') params.branch = branch;
  const res = await API.get('/dashboard-builder/render', { params });
  return res.data;
};

// Re-run ONE widget of the viewer's own layout — used when a widget needs fresh
// data on its own (an action widget after it acts, or a branch-shaped widget
// whose branch picker changed) rather than refetching the whole dashboard.
// Scope clamping on the server is identical to the full render.
export const renderDashboardWidget = async ({ id, branch, businessDate, dateRange = {} } = {}) => {
  const params = { id };
  if (branch && branch !== 'all') params.branch = branch;
  // A single operating date (End of Day), distinct from the reporting range.
  if (businessDate) params.businessDate = businessDate;
  if (dateRange.startDate && dateRange.endDate) {
    params.startDate = dateRange.startDate;
    params.endDate = dateRange.endDate;
  }
  const res = await API.get('/dashboard-builder/render/widget', { params });
  return res.data?.data || null;
};

// Widget catalog + scopes + the dashboard list for the builder palette. Every
// role permission set (scope='role') is one dashboard:
//   { key, label, roleId, roleKey, priority, maxScope, bound, hasLayout }
export const fetchWidgetCatalog = async () => {
  const res = await API.get('/dashboard-builder/catalog');
  return res.data;
};

// Just the dashboard list (no widget catalog) — for dashboard-binding selects.
export const fetchDashboards = async () => {
  const res = await API.get('/dashboard-builder/dashboards');
  return res.data?.data || [];
};

// A dashboard's saved layout plus the role that owns it ({ ...layout, role }).
export const fetchLayout = async (dashboardKey) => {
  const res = await API.get(`/dashboard-builder/layouts/${dashboardKey}`);
  return res.data;
};

// Save the layout AND bind it to its role. payload: { name, isPublished, widgets, maxScope }.
export const saveLayout = async (dashboardKey, payload) => {
  const res = await API.put(`/dashboard-builder/layouts/${dashboardKey}`, payload);
  return res.data; // { message, data: layout, role }
};
